import { Fragment } from 'react';
import clsx from 'clsx';

interface NotificationTogglesProps {
	notifications: {
		background_mode: boolean;
		notification: boolean;
	};
	isOpenBackgroundMode: boolean;
	handleBackgroundModeToggle: () => void;
	toggleNotification: (type: 'notification' | 'background_mode') => void;
}

export const NotificationToggles = ({ notifications, handleBackgroundModeToggle, toggleNotification, isOpenBackgroundMode }: NotificationTogglesProps) => {
	return (
		<div className="notifications">
			<h2 className="section-title">Bildirimler</h2>
			<div className="notification-item">
				<span className="notification-text">Görüşmelerinizle ilgili bildirimleri açın</span>
				<button
					className={clsx('toggle-switch', {
						off: !notifications?.notification
					})}
					onClick={() => toggleNotification('notification')}
					aria-label="Toggle notifications"
				/>
			</div>
			{isOpenBackgroundMode && (
				<Fragment>
					<h2 className="section-title">Arka Plan Modunu Aç</h2>
					<div className="notification-item">
						<span className="notification-text">Öğrenciler canlı görüşme aradığında bildirim gönder</span>
						<button
							className={clsx('toggle-switch', {
								off: !notifications?.background_mode
							})}
							onClick={handleBackgroundModeToggle}
							aria-label="Toggle background mode"
						/>
					</div>
				</Fragment>
			)}
		</div>
	);
};
